import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { initiateLogin, verifyOTP as verifyOTPApi } from '../services/api';

/* ─── Google Font ────────────────────────────────────────────────────────────*/
const _fl = document.createElement('link');
_fl.rel = 'stylesheet';
_fl.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&family=DM+Mono:wght@400;500&display=swap';
if (!document.head.querySelector('[href*="DM+Sans"]')) document.head.appendChild(_fl);

/* ─── Navia logo (embedded, always works offline) ───────────────────────────*/
const LOGO_URI = 'data:image/png;base64,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';

/* ─── Inject global CSS ──────────────────────────────────────────────────────*/
const _css = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html,body{height:100%;font-family:'DM Sans',system-ui,sans-serif;font-size:14px}
  .nb-login-root{display:flex;flex-direction:row;min-height:100vh;background:#fff}
  .nb-left{width:52%;padding:32px 48px;display:flex;flex-direction:column;
    border-right:0.5px solid rgba(0,0,0,.09);background:#FAFBFF;overflow-y:auto}
  .nb-right{flex:1;display:flex;align-items:flex-start;justify-content:center;
    padding:32px 40px;overflow-y:auto;background:#fff}
  .nb-form-box{width:100%;max-width:400px;padding-top:8px}
  .nb-step-dots{display:flex;align-items:center;gap:6px;margin-bottom:24px}
  .nb-dot{height:4px;border-radius:99px;background:rgba(0,0,0,.15)}
  .nb-dot-active{background:#1B4FD8;width:32px}
  .nb-dot-done{background:#1D9E75;width:20px}
  .nb-dot-idle{width:20px}
  .nb-form-title{font-size:22px;font-weight:600;color:#0D0F12;margin-bottom:5px;letter-spacing:-.3px}
  .nb-form-sub{font-size:13px;color:#5A6272;margin-bottom:22px;line-height:1.6}
  .nb-fgrp{margin-bottom:16px}
  .nb-flbl{display:flex;justify-content:space-between;align-items:baseline;
    font-size:12px;font-weight:500;color:#5A6272;margin-bottom:6px}
  .nb-fhint{font-size:11px;color:#9BA3B0;font-weight:400}
  .nb-finp{width:100%;padding:11px 13px;border:1px solid rgba(0,0,0,.15);
    border-radius:8px;font-size:14px;color:#0D0F12;background:#F8F9FB;
    font-family:'DM Sans',sans-serif;outline:none;transition:border .15s,box-shadow .15s}
  .nb-finp:focus{border-color:#1B4FD8;box-shadow:0 0 0 3px rgba(27,79,216,.12);background:#fff}
  .nb-finp::placeholder{color:#9BA3B0}

  /* ── DOB field (mobile-aware) ── */
  .nb-dob-wrap{position:relative;width:100%}
  .nb-dob-inp{width:100%;padding:11px 48px 11px 13px;border:1px solid rgba(0,0,0,.15);
    border-radius:8px;font-size:14px;color:#0D0F12;background:#F8F9FB;
    font-family:'DM Mono',monospace;letter-spacing:.5px;outline:none;
    transition:border .15s,box-shadow .15s}
  .nb-dob-inp:focus{border-color:#1B4FD8;box-shadow:0 0 0 3px rgba(27,79,216,.12);background:#fff}
  .nb-dob-inp::placeholder{color:#9BA3B0;font-family:'DM Sans',sans-serif;letter-spacing:0;font-size:13px}
  .nb-dob-inp.nb-dob-filled{border-color:#1B4FD8}
  .nb-dob-cal-btn{position:absolute;right:8px;top:50%;transform:translateY(-50%);
    width:32px;height:32px;background:#EEF2FF;border:none;border-radius:7px;
    display:flex;align-items:center;justify-content:center;cursor:pointer;
    color:#1B4FD8;flex-shrink:0;transition:background .15s}
  .nb-dob-cal-btn:hover{background:#dde8ff}
  /* hidden native date input layered over cal button for picker */
  .nb-dob-native{position:absolute;right:8px;top:50%;transform:translateY(-50%);
    width:32px;height:32px;opacity:0;cursor:pointer;z-index:2}
  .nb-dob-hint{font-size:11px;color:#9BA3B0;margin-top:5px;
    display:flex;align-items:center;gap:4px}

  .nb-terms-row{display:flex;align-items:flex-start;gap:10px;padding:13px;
    background:#F8F9FB;border:0.5px solid rgba(0,0,0,.09);border-radius:8px;
    margin-bottom:18px;cursor:pointer}
  .nb-terms-row input[type=checkbox]{width:15px;height:15px;accent-color:#1B4FD8;
    cursor:pointer;flex-shrink:0;margin-top:2px}
  .nb-terms-txt{font-size:13px;color:#5A6272;line-height:1.55}
  .nb-terms-txt a{color:#1B4FD8;text-decoration:none;font-weight:500}
  .nb-pri-btn{width:100%;background:#1B4FD8;color:#fff;border:none;border-radius:8px;
    padding:13px;font-size:14px;font-weight:500;cursor:pointer;
    font-family:'DM Sans',sans-serif;display:flex;align-items:center;
    justify-content:center;gap:8px;transition:background .15s}
  .nb-pri-btn:hover{background:#1338A8}
  .nb-pri-btn:disabled{opacity:.45;cursor:not-allowed}
  .nb-sec-note{display:flex;align-items:center;justify-content:center;
    gap:6px;font-size:11.5px;color:#9BA3B0;margin-top:14px}
  .nb-status-pill{display:inline-flex;align-items:center;gap:7px;background:#EEF2FF;
    color:#0C447C;border:0.5px solid rgba(27,79,216,.2);border-radius:99px;
    padding:5px 14px;font-size:12px;font-weight:500;margin-bottom:20px;width:fit-content}
  .nb-sdot{width:7px;height:7px;border-radius:50%;background:#1B4FD8;flex-shrink:0}
  .nb-hero-title{font-size:clamp(26px,3vw,38px);font-weight:600;line-height:1.15;
    color:#0D0F12;margin-bottom:14px;letter-spacing:-.5px}
  .nb-hero-title span{color:#1B4FD8}
  .nb-hero-desc{font-size:14px;color:#5A6272;line-height:1.75;margin-bottom:24px}
  .nb-feat-list{display:flex;flex-direction:column;gap:12px;margin-bottom:24px}
  .nb-feat{display:flex;align-items:flex-start;gap:12px;font-size:13px;color:#5A6272}
  .nb-feat-ic{width:26px;height:26px;border-radius:7px;display:flex;align-items:center;
    justify-content:center;font-size:13px;flex-shrink:0;margin-top:1px}
  .nb-help-card{background:#fff;border:0.5px solid rgba(0,0,0,.09);border-radius:10px;
    padding:16px 18px;margin-bottom:20px}
  .nb-help-title{font-size:11px;font-weight:600;color:#5A6272;text-transform:uppercase;
    letter-spacing:.06em;margin-bottom:10px}
  .nb-help-link{display:flex;align-items:center;gap:8px;font-size:13px;color:#1B4FD8;
    text-decoration:none;margin-bottom:7px}
  .nb-help-link:last-child{margin-bottom:0}
  .nb-left-footer{font-size:11px;color:#9BA3B0;line-height:1.7;padding-top:16px;
    border-top:0.5px solid rgba(0,0,0,.09);margin-top:auto;flex-shrink:0}
  .nb-otp-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:8px;
    margin-bottom:14px;width:100%}
  .nb-otp-inp{width:100%;text-align:center;font-size:22px;font-weight:500;
    padding:13px 4px;border:1px solid rgba(0,0,0,.15);border-radius:8px;
    background:#F8F9FB;color:#0D0F12;font-family:'DM Mono',monospace;
    outline:none;transition:border .15s,box-shadow .15s;min-width:0}
  .nb-otp-inp:focus{border-color:#1B4FD8;box-shadow:0 0 0 3px rgba(27,79,216,.12)}
  .nb-otp-inp.filled{border-color:#1B4FD8;background:#EEF2FF}
  .nb-otp-info{background:#EEF2FF;border:0.5px solid rgba(27,79,216,.2);border-radius:8px;
    padding:11px 13px;font-size:12px;color:#0C447C;line-height:1.6;
    margin-bottom:16px;display:flex;gap:8px}
  .nb-timer-bar{background:#F8F9FB;border:0.5px solid rgba(0,0,0,.09);border-radius:8px;
    padding:11px 14px;margin-bottom:12px}
  .nb-timer-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:6px}
  .nb-timer-lbl{font-size:12px;color:#5A6272}
  .nb-timer-val{font-size:14px;font-weight:600;color:#0D0F12;font-family:'DM Mono',monospace}
  .nb-timer-val.urgent{color:#DC2626}
  .nb-timer-track{height:4px;background:rgba(0,0,0,.09);border-radius:99px;overflow:hidden}
  .nb-timer-prog{height:100%;background:#1B4FD8;border-radius:99px;transition:width .9s linear}
  .nb-timer-prog.urgent{background:#DC2626}
  .nb-resend-row{text-align:center;margin-bottom:14px}
  .nb-resend-btn{background:none;border:none;cursor:pointer;font-size:12px;
    color:#9BA3B0;font-family:'DM Sans',sans-serif;padding:0}
  .nb-resend-btn.active{color:#1B4FD8}
  .nb-back-btn{display:flex;align-items:center;justify-content:center;gap:5px;
    color:#1B4FD8;font-size:13px;cursor:pointer;background:none;border:none;
    font-family:'DM Sans',sans-serif;margin-top:12px;padding:0;width:100%}
  .nb-back-btn:hover{text-decoration:underline}
  .nb-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);
    display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px}
  .nb-tbox{background:#fff;border-radius:14px;width:100%;max-width:540px;
    max-height:82vh;display:flex;flex-direction:column;border:0.5px solid rgba(0,0,0,.15)}
  .nb-tbhdr{padding:18px 20px 14px;border-bottom:0.5px solid rgba(0,0,0,.09);
    display:flex;justify-content:space-between;align-items:center;flex-shrink:0}
  .nb-tbbody{padding:18px 20px;overflow-y:auto;font-size:13px;
    color:#5A6272;line-height:1.8;flex:1}
  .nb-tbftr{padding:14px 20px;border-top:0.5px solid rgba(0,0,0,.09);
    flex-shrink:0;display:flex;flex-direction:column;gap:14px}
  .nb-tc-accept-btn{flex:2;height:42px;background:#1B4FD8;border:none;border-radius:8px;
    color:#fff;font-size:13px;font-weight:600;cursor:pointer;
    font-family:'DM Sans',sans-serif;transition:.15s}
  .nb-tc-accept-btn:disabled{opacity:.45;cursor:not-allowed}
  .nb-tc-cancel-btn{flex:1;height:42px;background:transparent;
    border:0.5px solid rgba(0,0,0,.15);border-radius:8px;color:#0D0F12;
    font-size:13px;cursor:pointer;font-family:'DM Sans',sans-serif}
  /* ── Mobile header ── */
  .nb-mobile-hdr{display:none}
  @media(max-width:768px){
    .nb-login-root{flex-direction:column}
    .nb-left{display:none}
    .nb-mobile-hdr{
      display:flex;flex-direction:column;align-items:center;
      background:linear-gradient(135deg,#1B4FD8 0%,#1338A8 100%);
      padding:28px 24px 24px;text-align:center;
    }
    .nb-mobile-hdr-logo-wrap{
      background:#fff;border-radius:12px;padding:8px 18px;
      margin-bottom:14px;display:inline-flex;align-items:center;justify-content:center;
      box-shadow:0 2px 8px rgba(0,0,0,.15);
    }
    .nb-mobile-hdr-logo{height:32px;width:auto;object-fit:contain;display:block}
    .nb-mobile-hdr-name{font-size:20px;font-weight:600;color:#fff;letter-spacing:-.3px;margin-bottom:4px}
    .nb-mobile-hdr-sub{font-size:12px;color:rgba(255,255,255,.75);line-height:1.5}
    .nb-mobile-pill{
      display:inline-flex;align-items:center;gap:6px;
      background:rgba(255,255,255,.15);border:0.5px solid rgba(255,255,255,.3);
      border-radius:99px;padding:4px 12px;font-size:11px;font-weight:500;
      color:#fff;margin-top:12px;
    }
    .nb-mobile-pill-dot{width:6px;height:6px;border-radius:50%;background:#4ADE80;flex-shrink:0}
    .nb-right{min-height:auto;padding:24px 20px;align-items:flex-start}
    .nb-form-box{max-width:100%}
  }
  @media(max-width:480px){
    .nb-otp-grid{gap:6px}
    .nb-otp-inp{font-size:17px;padding:10px 2px}
    .nb-mobile-hdr{padding:22px 20px 20px}
  }
`;
function injectCSS(id, css){
  let el = document.getElementById(id);
  if(!el){el=document.createElement('style');el.id=id;document.head.appendChild(el);}
  el.textContent=css;
}

/* ═══════════════════════════════════════════════════════════════════════════
   DOB HELPERS
   Single text input that auto-inserts slashes as user types digits:
   "15" → "15/" → "1508" → "15/08/" → "15081990" → "15/08/1990"
   Calendar icon opens a hidden native <input type="date"> for picker fallback.
   Output: YYYY-MM-DD string for the API (same format original code expected).
═══════════════════════════════════════════════════════════════════════════ */
function formatDobDisplay(raw) {
  // raw = digits only, max 8
  const d = raw.replace(/\D/g,'').slice(0,8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return d.slice(0,2) + '/' + d.slice(2);
  return d.slice(0,2) + '/' + d.slice(2,4) + '/' + d.slice(4);
}

function dobDisplayToYMD(display) {
  // display = "DD/MM/YYYY", returns "YYYY-MM-DD" or ""
  const parts = display.split('/');
  if (parts.length !== 3 || parts[2].length !== 4) return '';
  const [dd, mm, yyyy] = parts;
  if (!dd || !mm || !yyyy) return '';
  return `${yyyy}-${mm.padStart(2,'0')}-${dd.padStart(2,'0')}`;
}

function dobYMDToDisplay(ymd) {
  // "YYYY-MM-DD" → "DD/MM/YYYY"
  if (!ymd) return '';
  const [yyyy, mm, dd] = ymd.split('-');
  if (!yyyy || !mm || !dd) return '';
  return `${dd}/${mm}/${yyyy}`;
}

// ── DOB validation: no future dates, must be 18+ ───────────────────────────
function getMaxDobForAge18() {
  const now = new Date();
  const y = now.getFullYear() - 18;
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
function validateDobAge(ymd) {
  if (!ymd) return '';
  const dobDate = new Date(ymd + 'T00:00:00');
  if (isNaN(dobDate.getTime())) return 'Please enter a valid date.';
  const today = new Date(); today.setHours(0,0,0,0);
  if (dobDate.getTime() > today.getTime()) return 'Date of birth cannot be in the future.';
  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) age--;
  if (age < 18) return 'You must be at least 18 years old to use this portal.';
  return '';
}


/* ═══════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════════════ */
export default function Login({ onLoginSuccess }) {
  const [step, setStep]             = useState(1);
  const [ucc, setUcc]               = useState('');
  const [dob, setDob]               = useState('');           // always YYYY-MM-DD
  const [dobDisplay, setDobDisplay] = useState('');           // DD/MM/YYYY for input
  const [dobError, setDobError]     = useState('');
  const [termsAccepted, setTerms]   = useState(false);
  const [showTerms, setShowTerms]   = useState(false);
  const [modalChecked, setMChk]     = useState(false);
  const [otp, setOtp]               = useState(['','','','','','']);
  const [otpSecs, setOtpSecs]       = useState(300);
  const [resendCD, setResendCD]     = useState(60);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');
  const [sessionId, setSessionId]   = useState('');
  const [maskedMobile, setMaskedMobile] = useState('');
  const [maskedEmail,  setMaskedEmail]  = useState('');
  // Account Status system (2026-07-29): non-null while the Dormant/
  // reactivate popup should be shown. { message, reactivateUrl } shape
  // matches what auth.js now returns for a SUSPENDED account_status.
  const [dormantInfo, setDormantInfo] = useState(null);

  const otpRef0 = useRef(null); const otpRef1 = useRef(null);
  const otpRef2 = useRef(null); const otpRef3 = useRef(null);
  const otpRef4 = useRef(null); const otpRef5 = useRef(null);
  const otpRefs = [otpRef0, otpRef1, otpRef2, otpRef3, otpRef4, otpRef5];
  const timerRef    = useRef(null);
  const nativeDobRef = useRef(null); // hidden <input type="date"> for picker

  // useLayoutEffect (not useEffect) -- runs synchronously before the browser
  // paints, so the stylesheet is in place before the first frame is drawn.
  // This still only runs when THIS component actually mounts (unlike
  // module-scope injection), so it can never bleed into other login pages.
  useLayoutEffect(() => { injectCSS('nb-login-css', _css); }, []);

  /* ── OTP timer ── */
  useEffect(() => {
    if (step !== 2) return;
    setOtpSecs(300); setResendCD(60);
    timerRef.current = setInterval(() => {
      setOtpSecs(s => { if(s<=1){clearInterval(timerRef.current);return 0;} return s-1; });
      setResendCD(r => r>0 ? r-1 : 0);
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [step]);

  const fmtTime  = s => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;
  const canSend  = ucc.trim().length>=5 && ucc.trim().length<=8 && dob && !dobError && termsAccepted;
  const otpFull  = otp.every(d => d !== '');

  /* ── DOB text input handler ── */
  const handleDobInput = (e) => {
  const raw     = e.target.value;
  const digits  = raw.replace(/\D/g,'').slice(0,8);
  const display = formatDobDisplay(digits);
  setDobDisplay(display);
  const ymd = dobDisplayToYMD(display);
  setDob(ymd);
  setDobError(ymd ? validateDobAge(ymd) : '');
};

  /* ── DOB calendar (native picker) change ── */
  const handleNativeDateChange = (e) => {
  const ymd = e.target.value;
  setDob(ymd);
  setDobDisplay(dobYMDToDisplay(ymd));
  setDobError(ymd ? validateDobAge(ymd) : '');
};

  /* ── Calendar icon click → trigger hidden native input ── */
  const openCalendar = () => {
    if (nativeDobRef.current) nativeDobRef.current.click();
  };

  /* ── Send OTP ── */
  const handleSendOTP = async () => {
    setLoading(true); setError('');
    try {
      const res  = await initiateLogin(ucc.trim().toUpperCase(), dob);
      const data = res.data;
      if (!data.sessionId) throw new Error(data.error || 'Failed to send OTP');
      setSessionId(data.sessionId);
      setMaskedMobile(data.maskedMobile || '');
      setMaskedEmail(data.maskedEmail || '');
      setStep(2);
    } catch (err) {
      // Account Status system (2026-07-29): a SUSPENDED account gets the
      // Dormant/reactivate popup instead of the plain inline error below.
      // This is the ONLY new branch -- every other error (invalid UCC/DOB,
      // a CLOSED account, network failure, etc.) falls through to the
      // exact same line that already existed, unchanged. A CLOSED account's
      // message displays correctly through that existing line already,
      // since the backend puts its text in `error`, same as every other
      // error response this page has always handled.
      const respData = err.response?.data;
      if (respData?.errorCode === 'ACCOUNT_SUSPENDED') {
        setDormantInfo({ message: respData.error, reactivateUrl: respData.reactivateUrl });
        setLoading(false);
        return;
      }
      const msg = err.response?.data?.error || err.response?.data?.message || err.message || 'Failed to send OTP. Please try again.';
      setError(msg);
    }
    setLoading(false);
  };

  /* ── Verify OTP ── */
  const handleVerify = async () => {
    setLoading(true); setError('');
    try {
      const res  = await verifyOTPApi(sessionId, otp.join(''));
      const data = res.data;
      if (!data.token) throw new Error(data.error || 'Invalid OTP');
      localStorage.setItem('nb_token', data.token);
      localStorage.setItem('nb_client', JSON.stringify({
        name:   data.clientName,
        ucc:    data.ucc,
        mobile: data.mobile || '',
        email:  data.email  || '',
        dob:    data.dob    || ''
      }));
      clearInterval(timerRef.current);
      onLoginSuccess({
        clientName: data.clientName,
        ucc:        data.ucc,
        mobile:     data.mobile || '',
        email:      data.email  || '',
        dob:        data.dob    || ''
      });
    } catch (err) {
      // Account Status system (2026-07-29): defense-in-depth re-check --
      // if the account was suspended/closed in the window between OTP
      // send and verify, surface the same popup/message here too. Both
      // branches return early; anything else (invalid/expired OTP, etc.)
      // falls through to the exact original line, unchanged.
      const respData = err.response?.data;
      if (respData?.errorCode === 'ACCOUNT_SUSPENDED') {
        setDormantInfo({ message: respData.error, reactivateUrl: respData.reactivateUrl });
        setLoading(false);
        return;
      }
      if (respData?.errorCode === 'ACCOUNT_CLOSED') {
        setError(respData.error);
        setLoading(false);
        return;
      }
      setError(err.message || 'Invalid OTP. Please try again.');
    }
    setLoading(false);
  };

  /* ── OTP input handling ── */
  const handleOtpInput = (val, idx) => {
    const v = val.replace(/[^0-9]/g,'');
    const next = [...otp]; next[idx] = v;
    setOtp(next);
    if (v && idx < 5) otpRefs[idx+1].current?.focus();
  };
  const handleOtpKeyDown = (e, idx) => {
    if (e.key==='Backspace' && !otp[idx] && idx>0) {
      otpRefs[idx-1].current?.focus();
      const next=[...otp]; next[idx-1]=''; setOtp(next);
    }
  };

  /* ── Accept terms → auto-proceed if form complete ── */
  const acceptTerms = () => {
    setTerms(true); setShowTerms(false); setMChk(false);
    if (ucc.trim().length>=5 && ucc.trim().length<=8 && dob) {
      setTimeout(handleSendOTP, 100);
    }
  };

  /* ─── Left Panel ─── */
  const LeftPanel = ({ isOTP }) => (
    <div className="nb-left">
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:28,flexShrink:0}}>
        <img src={LOGO_URI} style={{height:36,width:'auto',objectFit:'contain'}} alt="Navia Markets"/>
        <div>
          <div style={{fontSize:15,fontWeight:600,color:'#0D0F12'}}>Navia Backup</div>
          <div style={{fontSize:11,color:'#9BA3B0'}}>by Navia Markets Ltd</div>
        </div>
      </div>
      <div className="nb-status-pill">
        <span className="nb-sdot"/>
        {isOTP ? 'Identity verification' : 'Emergency access system'}
      </div>
      {isOTP ? (
        <>
          <h1 className="nb-hero-title">One last step<br/>to <span>secure access</span></h1>
          <p className="nb-hero-desc">We've sent a 6-digit OTP to {maskedMobile || 'your registered mobile number'} and {maskedEmail || 'your registered email address'}. Enter it within 5 minutes to access your account.</p>
          <div className="nb-feat-list">
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#EEF2FF'}}>⏱</div><span>OTP valid for 5 minutes only</span></div>
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#E8F5E9'}}>🔒</div><span>Never share your OTP — Navia will never ask for it</span></div>
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#FFF8E1'}}>📱</div><span>Check registered mobile and email inbox</span></div>
          </div>
          <div className="nb-help-card">
            <div className="nb-help-title">Didn't receive OTP?</div>
            <div style={{fontSize:13,color:'#5A6272',lineHeight:1.7}}>Check spam folder &nbsp;·&nbsp; Ensure mobile network is active &nbsp;·&nbsp; Wait 60 seconds before requesting again</div>
          </div>
        </>
      ) : (
        <>
          <h1 className="nb-hero-title">Protect your trades<br/>during <span>platform downtime</span></h1>
          <p className="nb-hero-desc">When the primary trading platform is unavailable, Navia Backup lets you square off open positions at market price — keeping you in control during critical moments.</p>
          <div className="nb-feat-list">
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#FFF8E1'}}>⚡</div><span>Square off existing positions instantly at market price</span></div>
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#E8F5E9'}}>✓</div><span>NSE, BSE &amp; MCX segments supported</span></div>
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#FFF3E0'}}>🔒</div><span>OTP verified secure access every session</span></div>
            <div className="nb-feat"><div className="nb-feat-ic" style={{background:'#EEF2FF'}}>📊</div><span>View net, day &amp; B/F positions with real-time data</span></div>
          </div>
          <div className="nb-help-card">
            <div className="nb-help-title">Need help?</div>
            <a href="mailto:support@navia.co.in" className="nb-help-link">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              support@navia.co.in
            </a>
            <a href="https://support.navia.co.in" target="_blank" rel="noreferrer" className="nb-help-link">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
              support.navia.co.in
            </a>
          </div>
        </>
      )}
      <div className="nb-left-footer">
        Navia Markets Ltd &nbsp;·&nbsp; naviabackup.co.in<br/>
        Trades via this portal will not reflect immediately in the main app.
      </div>
    </div>
  );

  /* ─── Terms Modal ─── */
  const TermsModal = () => (
    <div className="nb-modal-overlay" onClick={e => e.target===e.currentTarget && setShowTerms(false)}>
      <div className="nb-tbox">
        <div className="nb-tbhdr">
          <div style={{fontSize:15,fontWeight:600,color:'#0D0F12'}}>Terms &amp; Conditions</div>
          <button onClick={() => setShowTerms(false)} style={{background:'none',border:'none',cursor:'pointer',color:'#5A6272',fontSize:18}}>✕</button>
        </div>
        <div className="nb-tbbody">
          <div style={{display:'flex',alignItems:'flex-start',gap:12,marginBottom:20,padding:14,background:'#FFFBEB',border:'0.5px solid #D97706',borderRadius:8}}>
            <div style={{width:36,height:36,background:'#FFF3CD',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </div>
            <div>
              <div style={{fontSize:14,fontWeight:600,color:'#0D0F12',marginBottom:2}}>Navia Backup — Important Instructions</div>
              <div style={{fontSize:12,color:'#5A6272'}}>Please read carefully before proceeding</div>
            </div>
          </div>
          <ol style={{listStyle:'none',display:'flex',flexDirection:'column',gap:12}}>
            {[
              'Square-off option is enabled only during downtime.',
              'Only market square-off for full qty is allowed.',
              'Orders go to Exchange on a best-effort, 5-min cycle.',
              'T+1 shares (bought yesterday) cannot be sold today.',
              'Once placed, square-off will be executed.',
              'Trade confirmation sent via WhatsApp.',
              'As a stand-alone system, trades may not reflect immediately in the App.',
              'Do not repeat trades when the App resumes.',
              'Navia is not liable for losses using Backup.',
            ].map((text, i) => (
              <li key={i} style={{display:'flex',alignItems:'flex-start',gap:12}}>
                <span style={{minWidth:24,height:24,background:'#EEF2FF',color:'#0C447C',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:600,flexShrink:0,marginTop:1}}>{i+1}</span>
                <span style={{fontSize:13,color:'#5A6272',lineHeight:1.6}}>{text}</span>
              </li>
            ))}
            <li style={{display:'flex',alignItems:'flex-start',gap:12}}>
              <span style={{minWidth:24,height:24,background:'#EEF2FF',color:'#0C447C',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:600,flexShrink:0,marginTop:1}}>10</span>
              <span style={{fontSize:13,color:'#5A6272',lineHeight:1.6}}>More details on <a href="https://support.navia.co.in" target="_blank" rel="noreferrer" style={{color:'#1B4FD8'}}>Navia Support</a>.</span>
            </li>
          </ol>
        </div>
        <div className="nb-tbftr">
          <div style={{display:'flex',alignItems:'flex-start',gap:10}}>
            <input type="checkbox" id="tc-modal-chk" checked={modalChecked}
              onChange={e => setMChk(e.target.checked)}
              style={{width:16,height:16,accentColor:'#1B4FD8',flexShrink:0,marginTop:2,cursor:'pointer'}}/>
            <label htmlFor="tc-modal-chk" style={{fontSize:13,color:'#5A6272',lineHeight:1.55,cursor:'pointer'}}>
              I have read and understood all the above instructions
            </label>
          </div>
          <div style={{display:'flex',gap:10}}>
            <button className="nb-tc-cancel-btn" onClick={() => setShowTerms(false)}>Cancel</button>
            <button className="nb-tc-accept-btn" disabled={!modalChecked} onClick={acceptTerms}>
              Accept &amp; Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  /* ─── Dormant / Reactivate Modal (2026-07-29) ─────────────────────────────
     Shown when the backend blocks login because account_status is
     SUSPENDED. Reuses the same modal CSS classes as TermsModal above so it
     matches the existing visual language exactly -- no new CSS added. */
  const DormantModal = () => (
    <div className="nb-modal-overlay" onClick={e => e.target===e.currentTarget && setDormantInfo(null)}>
      <div className="nb-tbox" style={{maxWidth:440}}>
        <div className="nb-tbhdr">
          <div style={{fontSize:15,fontWeight:600,color:'#0D0F12'}}>Account Reactivation Required</div>
          <button onClick={() => setDormantInfo(null)} style={{background:'none',border:'none',cursor:'pointer',color:'#5A6272',fontSize:18}}>✕</button>
        </div>
        <div className="nb-tbbody">
          <div style={{display:'flex',alignItems:'flex-start',gap:12,marginBottom:16,padding:14,background:'#FFFBEB',border:'0.5px solid #D97706',borderRadius:8}}>
            <div style={{width:36,height:36,background:'#FFF3CD',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </div>
            <div>
              <div style={{fontSize:14,fontWeight:600,color:'#0D0F12',marginBottom:2}}>Your account is Dormant</div>
              <div style={{fontSize:12,color:'#5A6272'}}>{dormantInfo?.message}</div>
            </div>
          </div>
          <p style={{fontSize:13,color:'#5A6272',lineHeight:1.7}}>
            To regain access, please complete the reactivation process (re-KYC) using the button below.
          </p>
        </div>
        <div className="nb-tbftr">
          <div style={{display:'flex',gap:10}}>
            <button className="nb-tc-cancel-btn" onClick={() => setDormantInfo(null)}>Close</button>
            <a
              href={dormantInfo?.reactivateUrl || 'https://rekyc.navia.co.in/login.php'}
              target="_blank" rel="noreferrer"
              className="nb-tc-accept-btn"
              style={{textDecoration:'none',display:'flex',alignItems:'center',justifyContent:'center'}}
            >
              Reactivate Account
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  /* ─── Render ─── */
  return (
    <div className="nb-login-root">
      {showTerms && <TermsModal />}
      {dormantInfo && <DormantModal />}

      {/* Mobile branded header */}
      <div className="nb-mobile-hdr">
        <div className="nb-mobile-hdr-logo-wrap">
          <img src={LOGO_URI} className="nb-mobile-hdr-logo" alt="Navia Markets"/>
        </div>
        <div className="nb-mobile-hdr-name">Navia Backup</div>
        <div className="nb-mobile-hdr-sub">
          Emergency square-off portal{step===2 ? ' · Identity verification' : ''}
        </div>
        <div className="nb-mobile-pill">
          <span className="nb-mobile-pill-dot"/>
          {step===2 ? 'Verify OTP' : 'Emergency access system'}
        </div>
      </div>

      <LeftPanel isOTP={step===2} />

      <div className="nb-right">
        {/* ── STEP 1: Login form ── */}
        {step===1 && (
          <div className="nb-form-box">
            <div className="nb-step-dots">
              <div className="nb-dot nb-dot-active" />
              <div className="nb-dot nb-dot-idle" />
            </div>
            <h2 className="nb-form-title">Sign in to your account</h2>
            <p className="nb-form-sub">Enter your UCC and date of birth to continue</p>

            {/* UCC — unchanged */}
            <div className="nb-fgrp">
              <div className="nb-flbl">
                UCC (Unique Client Code)
                <span className="nb-fhint">5–8 alphanumeric (e.g. AB1234)</span>
              </div>
              <input className="nb-finp" type="text" placeholder="Enter your UCC"
                value={ucc} onChange={e => setUcc(e.target.value.toUpperCase())}
                maxLength={8} autoComplete="username" inputMode="text"/>
            </div>

            {/* DOB — new single-input with auto-slash + calendar icon */}
            <div className="nb-fgrp">
              <div className="nb-flbl">
                Date of birth
                <span className="nb-fhint">DD/MM/YYYY</span>
              </div>
              <div className="nb-dob-wrap">
                <input
                  className={`nb-dob-inp${dobDisplay ? ' nb-dob-filled' : ''}`}
                  type="text"
                  inputMode="numeric"
                  placeholder="DD/MM/YYYY"
                  value={dobDisplay}
                  onChange={handleDobInput}
                  autoComplete="bday"
                  maxLength={10}
                />
                {/* Visible calendar button */}
                <button
                  type="button"
                  className="nb-dob-cal-btn"
                  onClick={openCalendar}
                  tabIndex={-1}
                  aria-label="Open calendar picker"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </button>
                {/* Hidden native date input — only used to open the OS picker */}
                <input
                  ref={nativeDobRef}
                  type="date"
                  className="nb-dob-native"
                  value={dob}
                  onChange={handleNativeDateChange}
                  tabIndex={-1}
                  aria-hidden="true"
                />
                <input
  ref={nativeDobRef}
  type="date"
  className="nb-dob-native"
  value={dob}
  max={getMaxDobForAge18()}
  onChange={handleNativeDateChange}
  tabIndex={-1}
  aria-hidden="true"
/>
              </div>
              <div className="nb-dob-hint">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Type digits directly · or tap the calendar icon to pick
              </div>
              {dobError && (
                <div style={{fontSize:11,color:'#DC2626',marginTop:5,display:'flex',alignItems:'center',gap:4}}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                  {dobError}
                </div>
              )}
            </div>

            {/* Terms row — unchanged */}
            <div className="nb-terms-row" onClick={() => setShowTerms(true)}>
              <input type="checkbox" checked={termsAccepted} readOnly
                onClick={e => {e.stopPropagation(); setShowTerms(true);}}
                style={{width:15,height:15,accentColor:'#1B4FD8',cursor:'pointer',flexShrink:0,marginTop:2}}/>
              <div className="nb-terms-txt">
                I agree to the{' '}
                <a href="#terms" onClick={e => {e.preventDefault();e.stopPropagation();setShowTerms(true);}}>
                  Terms &amp; Conditions
                </a>
                {' '}and important instructions. I understand square-off orders execute at market price and cannot be cancelled.
              </div>
            </div>

            {error && <div style={{fontSize:12,color:'#DC2626',marginBottom:12}}>{error}</div>}
            <button className="nb-pri-btn" disabled={!canSend || loading} onClick={handleSendOTP}>
              {loading ? 'Sending OTP…' : 'Send OTP'}
              {!loading && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>}
            </button>
            <div className="nb-sec-note">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
              OTP verified &nbsp;·&nbsp; SEBI registered broker
            </div>
          </div>
        )}

        {/* ── STEP 2: OTP ── */}
        {step===2 && (
          <div className="nb-form-box">
            <div className="nb-step-dots">
              <div className="nb-dot nb-dot-done" />
              <div className="nb-dot nb-dot-active" />
            </div>
            <h2 className="nb-form-title">Verify your identity</h2>
            <p className="nb-form-sub">OTP sent to {maskedMobile || 'your registered mobile'} and {maskedEmail || 'your registered email'}</p>
            <div className="nb-otp-info">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0,marginTop:1}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Enter the 6-digit OTP. Valid for 5 minutes only. Do not share with anyone.
            </div>
            <div style={{marginBottom:8}}>
              <div style={{fontSize:12,fontWeight:500,color:'#5A6272',marginBottom:9}}>6-digit OTP</div>
              <div className="nb-otp-grid">
                {otp.map((d, i) => (
                  <input key={i} ref={otpRefs[i]} className={'nb-otp-inp'+(d?' filled':'')}
                    type="text" maxLength={1} inputMode="numeric"
                    value={d} onChange={e => handleOtpInput(e.target.value, i)}
                    onKeyDown={e => handleOtpKeyDown(e, i)}
                    aria-label={`OTP digit ${i+1}`}/>
                ))}
              </div>
            </div>
            <div className="nb-timer-bar">
              <div className="nb-timer-top">
                <span className="nb-timer-lbl">OTP expires in</span>
                <span className={'nb-timer-val'+(otpSecs<=60?' urgent':'')}>{fmtTime(otpSecs)}</span>
              </div>
              <div className="nb-timer-track">
                <div className={'nb-timer-prog'+(otpSecs<=60?' urgent':'')}
                  style={{width:`${(otpSecs/300)*100}%`}}/>
              </div>
            </div>
            <div className="nb-resend-row">
              <button className={'nb-resend-btn'+(resendCD<=0?' active':'')}
                disabled={resendCD>0} onClick={() => {setOtp(['','','','','','']);setOtpSecs(300);setResendCD(60);}}>
                {resendCD>0 ? `Resend OTP (available in ${fmtTime(resendCD)})` : 'Resend OTP'}
              </button>
            </div>
            {error && <div style={{fontSize:12,color:'#DC2626',marginBottom:12}}>{error}</div>}
            <button className="nb-pri-btn" disabled={!otpFull || loading || otpSecs===0} onClick={handleVerify}>
              {loading ? 'Verifying…' : 'Verify and sign in'}
              {!loading && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>}
            </button>
            <button className="nb-back-btn" onClick={() => { clearInterval(timerRef.current); setStep(1); setOtp(['','','','','','']); setError(''); }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
              Back to edit details
            </button>
          </div>
        )}
      </div>
    </div>
  );
}